import React, { ChangeEvent } from 'react';
import SearchIcon from '../../../icons/parcel-center-search.svg';

import styles from './FilterSearchInput.scss';
import { useTranslation } from 'react-i18next';

interface FilterSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const FilterSearchInput = ({
  value,
  onChange,
  placeholder = 'Search...',
}: FilterSearchInputProps): React.ReactElement => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <SearchIcon className={styles.icon} />
      <input
        type="text"
        className={styles.input}
        value={value}
        onChange={handleChange}
        placeholder={t(placeholder)}
        autoFocus
      />
    </div>
  );
};

export default FilterSearchInput;
